class InteractionInsight {
  id = 0;

  likesCount = 0;

  liked = false;

  viewsCount = 0;

  downloadsCount = 0;

  sharesCount = 0;

  constructor(likesCount = 0, liked = false, viewsCount = 0, downloadsCount = 0, id = 0, sharesCount = 0) {
    this.likesCount = likesCount;
    this.liked = liked;
    this.viewsCount = viewsCount;
    this.downloadsCount = downloadsCount;
    this.id = id;
    this.sharesCount = sharesCount;
  }

  /**
   *
   * @param data{{likes, liked, views, downloads}}
   * @returns {InteractionInsight}
   */
  static fromObject(data) {
    const {
      likes,
      liked,
      views,
      downloads,
      id,
      shares,
    } = data;

    return new InteractionInsight(likes, liked, views, downloads, id, shares);
  }
}

export default InteractionInsight;
